<template>
	<div>
		<div class="fs4 fw7 lh125 mt6">Bank References</div>
		<j-accordion
			v-for="i in 2"
			:key="i"
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="mr1">Details</span>
				{{ i }}
			</div>
			<div slot="body" class="p6 bg5">
				<case-form :schema="schemaBankReferenceList(i)" :isBoxed="false" />
			</div>
		</j-accordion>

		<div class="fs4 fw7 lh125 mt6">Other Financial Institutions</div>
		<j-accordion
			v-for="j in 1"
			:key="j"
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="mr1">Details</span>
				{{ j }}
			</div>
			<div slot="body" class="p6 bg5">
				<case-form :schema="schemaOtherList(j)" :isBoxed="false" />
			</div>
		</j-accordion>
		<case-form class="mt6" :schema="schemaAuthorize" />
	</div>
</template>

<script>
import CaseForm from "@/modules/caseManagement/components/CaseForm/CaseForm.vue"
import JAccordion from "@/components/JAccordion/"

export default {
	components: {
		CaseForm,
		JAccordion
	},

	computed: {
		schemaAuthorize() {
			return [
				{
					label: `Authorized Name of Contact at Financial Institution`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0authorizedContactAtFinancialInstitution`,
					props: {
						suggest: {
							typeIncludes: `authorizedContactAtFinancialInstitution`
						},
						createOptions: {
							type: `authorizedContactAtFinancialInstitution`,
							dataType: "string"
						}
					}
				},
				{
					label: `Authorized Financial Institution Name`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0authorizedFinancialInstitutionName`,
					props: {
						suggest: {
							typeIncludes: `authorizedFinancialInstitutionName`
						},
						createOptions: {
							type: `authorizedFinancialInstitutionName`,
							dataType: "string"
						}
					}
				}
			]
		}
	},

	methods: {
		schemaBankReferenceList(i) {
			return [
				{
					label: `Name of Bank`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0bankReferencesName${i}`,
					props: {
						suggest: {
							typeIncludes: `bankReferencesName${i}`
						},
						createOptions: {
							type: `bankReferencesName${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `City`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0bankReferencesCity${i}`,
					props: {
						suggest: {
							typeIncludes: `bankReferencesCity${i}`
						},
						createOptions: {
							type: `bankReferencesCity${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `State/Province`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0bankReferencesStateOrProvince${i}`,
					props: {
						suggest: {
							typeIncludes: `bankReferencesStateOrProvince${i}`
						},
						createOptions: {
							type: `bankReferencesStateOrProvince${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `Country`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0bankReferencesCountry${i}`,
					props: {
						suggest: {
							typeIncludes: `bankReferencesCountry${i}`
						},
						createOptions: {
							type: `bankReferencesCountry${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `Type of Account`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0bankReferencesTypeOfAccount${i}`,
					props: {
						suggest: {
							typeIncludes: `bankReferencesTypeOfAccount${i}`
						},
						createOptions: {
							type: `bankReferencesTypeOfAccount${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `Name of Contact`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0bankReferencesNameOfContact${i}`,
					props: {
						suggest: {
							typeIncludes: `bankReferencesNameOfContact${i}`
						},
						createOptions: {
							type: `bankReferencesNameOfContact${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `Title of Contact`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0bankReferencesTitleOfContact${i}`,
					props: {
						suggest: {
							typeIncludes: `bankReferencesTitleOfContact${i}`
						},
						createOptions: {
							type: `bankReferencesTitleOfContact${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `Telephone Number of Contact`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0bankReferencesTelOfContact${i}`,
					props: {
						suggest: {
							typeIncludes: `bankReferencesTelOfContact${i}`
						},
						createOptions: {
							type: `bankReferencesTelOfContact${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `Fax Number of Contact`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0bankReferencesFaxOfContact${i}`,
					props: {
						suggest: {
							typeIncludes: `bankReferencesFaxOfContact${i}`
						},
						createOptions: {
							type: `bankReferencesFaxOfContact${i}`,
							dataType: "string"
						}
					}
				}
			]
		},

		schemaOtherList(i) {
			return [
				{
					label: `Name of Institution`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0financialInstitutionName${i}`,
					props: {
						suggest: {
							typeIncludes: `financialInstitutionName${i}`
						},
						createOptions: {
							type: `financialInstitutionName${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `City`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0financialInstitutionCityy${i}`,
					props: {
						suggest: {
							typeIncludes: `financialInstitutionCity${i}`
						},
						createOptions: {
							type: `financialInstitutionCity${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `State/Province`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0financialInstitutionStateOrProvince${i}`,
					props: {
						suggest: {
							typeIncludes: `financialInstitutionStateOrProvince${i}`
						},
						createOptions: {
							type: `financialInstitutionStateOrProvince${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `Country`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0financialInstitutionCountry${i}`,
					props: {
						suggest: {
							typeIncludes: `financialInstitutionCountry${i}`
						},
						createOptions: {
							type: `financialInstitutionCountry${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `Type of Relationship`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0financialInstitutionRelationship${i}`,
					props: {
						suggest: {
							typeIncludes: `financialInstitutionRelationship${i}`
						},
						createOptions: {
							type: `financialInstitutionRelationship${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `Name of Contact`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0financialInstitutionContactName${i}`,
					props: {
						suggest: {
							typeIncludes: `financialInstitutionContactName${i}`
						},
						createOptions: {
							type: `financialInstitutionContactName${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `Title of Contact`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0financialInstitutionContactTitle${i}`,
					props: {
						suggest: {
							typeIncludes: `financialInstitutionContactTitle${i}`
						},
						createOptions: {
							type: `financialInstitutionContactTitle${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `Telephone Number of Contact`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0financialInstitutionContactTel${i}`,
					props: {
						suggest: {
							typeIncludes: `financialInstitutionContactTel${i}`
						},
						createOptions: {
							type: `financialInstitutionContactTel${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `Fax Number of Contact`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0financialInstitutionContactFax${i}`,
					props: {
						suggest: {
							typeIncludes: `financialInstitutionContactFax${i}`
						},
						createOptions: {
							type: `financialInstitutionContactFax${i}`,
							dataType: "string"
						}
					}
				}
			]
		}
	}
}
</script>
